import _Object$keys from 'babel-runtime/core-js/object/keys';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import Search from './search.vue';
import List from './list.vue';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import { fetchBillList, pushFinanceBill, billRenewal } from '@/api/finance/bill.ts';
import _ from 'lodash';
import { mapState } from 'vuex';
import billForm from './bill-form.vue';
import { format } from 'date-fns';
import { moduleType } from './options.js';

export default {
  props: [],
  components: {
    Search: Search,
    List: List,
    Pagination: Pagination,
    billForm: billForm
  },
  mixins: [searchMixin],
  data: function data() {
    return {
      pagination: {
        total: 0
      },
      query: {
        adv_id: '',
        timezone: '',
        module: '',
        time: [],
        invoice_name: '',
        company_name: '',
        address: '',
        bd_id: '',
        bd_team_id: '',
        bd_am_id: '',
        bd_am_team_id: '',
        pm_adv_id: '',
        pm_adv_team_id: '',
        page: 1,
        page_size: 15,
        order: '-created_time'
      },
      billDialog: {
        visible: false,
        bill: {}
      },
      billForm: {
        date: '',
        rev: 0,
        cost: 0
      },
      list: []
    };
  },

  computed: _extends({}, mapState({
    timeZoneList: function timeZoneList(state) {
      return state.config.timeZoneList;
    }
  })),
  watch: {
    $route: function $route(to, from) {
      this.getList(this.query);
    }
  },
  methods: {
    handlePush: function handlePush(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var getBillMonth;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.billDialog.visible = true;
                _this.billDialog.bill = item;

                getBillMonth = function getBillMonth() {
                  function getBillDate(inputDate) {
                    // 将输入转换为字符串，并提取年份和月份
                    var dateString = inputDate.toString();
                    var year = dateString.substring(0, 4); // 提取年份 'YYYY'
                    var month = dateString.substring(4, 6); // 提取月份 'MM'

                    return year + '-' + month; // 格式化为 'YYYY-MM'
                  }

                  // 账单类型为广告主账单，获取真实账期且不允许修改
                  if (item.module === moduleType.ADVERTISER) {
                    return getBillDate(item.start_date);
                  }
                  // 默认获取前一个月作为账期
                  var day = new Date().getDate() + 1;
                  return format(new Date().getTime() - day * 24 * 3600 * 1000, 'YYYY-MM');
                };

                _this.billForm.date = getBillMonth();
                _this.billForm.rev = item.revenue;
                _this.billForm.cost = item.cost;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    pushBill: function pushBill(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var validate, loading, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$refs['bill-form'].$refs['form'].validate();

              case 2:
                validate = _context2.sent;

                if (validate) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:
                loading = _this2.$loading({
                  lock: true,
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _context2.prev = 6;
                _context2.next = 9;
                return pushFinanceBill({
                  id: item.id,
                  settle_period: _this2.billForm.date,
                  revenue: _this2.billForm.rev,
                  cost: _this2.billForm.cost
                });

              case 9:
                res = _context2.sent;

                if (_.get(res, 'data.code') === 0) {
                  _this2.$message({
                    type: 'success',
                    message: '推送成功'
                  });
                }
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](6);

                console.log(_context2.t0);

              case 16:
                loading.close();
                _this2.billDialog.visible = false;
                _this2.getList(_this2.query);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[6, 13]]);
      }))();
    },
    handleRenewal: function handleRenewal(item) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var pushAction;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                pushAction = function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                    var loading, res;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            loading = _this3.$loading({
                              lock: true,
                              spinner: 'el-icon-loading',
                              background: 'rgba(0, 0, 0, 0.7)'
                            });
                            _context3.prev = 1;
                            _context3.next = 4;
                            return billRenewal({
                              id: item.id
                            });

                          case 4:
                            res = _context3.sent;

                            if (_.get(res, 'data.code') === 0) {
                              _this3.$message({
                                type: 'success',
                                message: '重新出账成功'
                              });
                            }
                            _context3.next = 11;
                            break;

                          case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](1);

                            console.log(_context3.t0);

                          case 11:
                            loading.close();
                            _context3.next = 14;
                            return _this3.getList(_this3.query);

                          case 14:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3, [[1, 8]]);
                  }));

                  return function pushAction() {
                    return _ref.apply(this, arguments);
                  };
                }();

                _this3.$confirm('是否重新出账？（出账不改变账单金额，仅影响账单关联广告主BD，BD-AM，PM-ADV及其对应的团队以及invoice信息）', '重新出账', {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  pushAction();
                });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    getList: function getList(data) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var res, tempList, sum;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return fetchBillList(data);

              case 3:
                res = _context5.sent;
                tempList = _.get(res, 'data.data.list') || [];
                sum = _.get(res, 'data.data.sum') || {};

                if (tempList.length) {
                  tempList.unshift(_this4.generateSumItem(tempList[0], sum));
                }
                _this4.list = tempList;
                _this4.pagination.total = _.get(res, 'data.data.total') || 0;
                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](0);

                console.log(_context5.t0);

              case 14:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4, [[0, 11]]);
      }))();
    },
    generateSumItem: function generateSumItem(item, sum) {
      var cloneItem = _.cloneDeep(item);
      _Object$keys(cloneItem).forEach(function (key) {
        cloneItem[key] = '-';
      });
      return _extends({}, cloneItem, {
        adv_name: 'Sum',
        revenue: sum.revenue,
        cost: sum.cost
      });
    }
  },
  mounted: function mounted() {
    this.getList(this.query);
    this.$store.dispatch('config/getTimeZoneList');
  }
};